import React from 'react';
import classNames from 'classnames';

import css from './AppPagePanel.module.css';

/**
 * The shared shell of the app-tier account-area pages (D27): one centred panel with the page h1
 * on the left of its header, an optional page action on the right, an optional supporting line
 * under the h1, a divider, then the page content.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules to the panel
 * @param {React.Node} props.title the page h1 content (one h1 per page)
 * @param {React.Node?} props.subtitle supporting copy under the h1
 * @param {React.Node?} props.action the page action (e.g. «Посмотреть профиль»)
 * @param {React.Node} props.children the page content
 * @returns {JSX.Element}
 */
const AppPagePanel = props => {
  const { className, title, subtitle, action, children } = props;
  return (
    <div className={css.root}>
      <div className={classNames(css.panel, className)}>
        <div className={css.header}>
          <div className={css.titleGroup}>
            <h1 className="delowo-text--app-page-title">{title}</h1>
            {subtitle ? <p className={css.subtitle}>{subtitle}</p> : null}
          </div>
          {action ? <div className={css.action}>{action}</div> : null}
        </div>
        {children}
      </div>
    </div>
  );
};

export default AppPagePanel;
